/**
 * Portal identity endpoints: sibling creator workspaces and session
 * exchange. Portal JWTs stay client-scoped — switching mints a new
 * session for the target client (see client_portal_me_routes.py).
 */

import type { HttpClient } from "@/core/http/types";
import type { CreatorWorkspace } from "../creatorWorkspaces";

export interface SwitchClientResponse {
  accessToken: string;
  refreshToken: string;
  clientId: string;
  clientName: string | null;
  role: string;
  expiresAt: string;
}

export const portalMeService = {
  async getMyClients(http: HttpClient): Promise<CreatorWorkspace[]> {
    const response = await http.get<{ clients: CreatorWorkspace[] }>(
      "/api/client-portal/me/clients"
    );
    return response.clients;
  },

  async switchClient(
    http: HttpClient,
    clientId: string
  ): Promise<SwitchClientResponse> {
    return http.post<SwitchClientResponse>("/api/client-portal/me/switch", {
      clientId,
    });
  },
};
